import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { getCurrentInstance, watch, ref } from 'vue';
import Note from '@/components/notes/Note.vue';
import constants from '@/utilities/constants';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuickNote',
  setup(__props) {

const _this = getCurrentInstance()!.proxy as any;

const noteId = ref(constants.newNote);

const handleCreate = (newVal: string) => {
  noteId.value = newVal;
};

const handleClose = () => {
  _this.$store.dispatch('setQuickNote', false);
};

watch(
  () => _this.$route.path,
  () => {
    handleClose();
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Note, {
    "is-quick-note": true,
    "note-id": noteId.value,
    onCreateNote: handleCreate,
    onClose: handleClose
  }, null, 8, ["note-id"]))
}
}

})